



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component
export default class SearchVehicles extends Vue {
    @Prop({ default: '' }) value: string;
    @Prop({ default: false }) dialog: boolean;
    @Prop({ default: false }) active: boolean;
    @Prop({ default: () => () => console.log('[SearchVehicles] Input') }) input: Function;

    @Watch('dialog')
    observableDialog(value) {
        value && this.value && this.input(this.value);
    }
}
